import Utils from '../utils';

export default class TriggerBase {
	loaded = false;
	listenerAdded = false;
	event;
	element;
	data;

	constructor( element ) {
		this.element = element;
		this.data = Utils.getData( element );
		this.eventHandler = ( event ) => { this.trigger( event ).then() };
	}

	/**
	 * Attach listener
	 */
	addListener() {
		return this.manageEvent();
	}

	/**
	 * remove listener
	 */
	removeListener() {
		return this.manageEvent( false );
	}

	/**
	 *  Manage event listeners, used to add or remove event listeners
	 * @param {boolean} setEventListener
	 */
	manageEvent( setEventListener = true ) {
		const method = setEventListener ? 'addEventListener' : 'removeEventListener';
		if ( ( setEventListener && this.listenerAdded ) || ( ! setEventListener && ! this.listenerAdded ) ) {
			return;
		}

		if ( ! Array.isArray( this.event ) ) {
			window[ method ]( this.event, this.eventHandler );
		} else {
			this.event.forEach( event => window[ method ]( event, this.eventHandler ) );
		}

		this.listenerAdded = setEventListener;
	}

	/**
	 * test should trigger lazy load
	 * @returns {boolean}
	 */
	shouldTrigger() {
		return ! this.loaded;
	}

	/**
	 * trigger lazy load if valid
	 * @returns {Promise<void>}
	 */
	async trigger( event = null ) { // eslint-disable-line no-unused-vars
		if ( ! this.shouldTrigger() ) {
			return;
		}
		this.removeListener();
		this.loaded = true;
		const {
			templateId = 0,
			widgetId = '',
			...restOfData
		} = this.data;
		const fetchedElement = await Utils.fetchElement( templateId, widgetId, restOfData );
		if ( ! fetchedElement ) {
			return;
		}
		this.insertElement( fetchedElement );
	}

	initFrontendHandlers( scope ) {
		const initElements = ( elementType, $innerScope ) => {
			if ( ! elementType ) {
				return;
			}

			window.elementorFrontend.hooks.doAction( 'frontend/element_ready/global', $innerScope, $ );
			window.elementorFrontend.hooks.doAction( `frontend/element_ready/${ elementType }`, $innerScope, $ );


			if ( 'widget' === elementType ) {
				const widgetType = $innerScope.attr( 'data-widget_type' );
				window.elementorFrontend.hooks.doAction( `frontend/element_ready/${ widgetType }`, $innerScope, $ );
			}
		}

		const $scope = jQuery( scope );
		initElements( $scope.attr( 'data-element_type' ), $scope );

		const initSubElement = ( element ) => {
			const $el = jQuery( element );
			initElements( $el.attr( 'data-element_type' ), $el );
		};
		$scope.find( '[data-element_type]' ).each( ( index, $currentElement ) => initSubElement( $currentElement ) );

	}


	/**
	 * insert element in placeholder
	 * @param fetchedElement
	 */
	insertElement( fetchedElement ) {
		const { css = [], js = [] } = fetchedElement;
		Utils.enqueueAssets( [ ...css, ...js ] );
		if ( ! this.element.parentElement ) {
			const { element } = this;
			Utils.log( {
				element,
				fetchedElement,
				message: 'This could be a non-lazyload supported element',
			}, 'error' );
			return;
		}

		const {
			templateId = 0,
			widgetId = '',
		} = this.data;

		const newElement = document.createElement( 'template' );
		newElement.innerHTML = fetchedElement.html.trim(); // Never return a text node of whitespace as the result
		this.newElement = newElement.content.firstChild;

		const eventData = {
			templateId,
			widgetId,
			element: this.newElement,
			trigger: this,
		};
		// allow alter before insert
		this.triggerEvent( 'insert/before', eventData );
		this.triggerEvent( `insert/before/${templateId}-${widgetId}`, eventData );

		this.element.replaceWith( this.newElement );

		if ( window?.elementorFrontend?.onDocumentLoaded ) {
			const initElementsDelayed = () => {
				try {
					this.initFrontendHandlers( this.newElement );
				} catch ( error ) {
					const { element } = this;
					Utils.log( {
						element,
						fetchedElement,
						error,
						message: 'This could be a non-lazyload supported element',
					}, 'error' );
				}
				this.__afterInsert();
			}

			setTimeout( initElementsDelayed, 50 );
		}
	}

	triggerEvent( eventName, data = '' ) {
		const onToggle = new CustomEvent( `widgetsLazyLoad/${ eventName }`, {
			bubbles: true,
			detail: data
		} );
		document.dispatchEvent( onToggle );
	}

	__afterInsert() {
		const {
			templateId = 0,
			widgetId = '',
		} = this.data;

		const eventData = {
			templateId,
			widgetId,
			element: this.element,
			trigger: this,
		};
		this.triggerEvent( 'insert/after', eventData );
		this.triggerEvent( `insert/after/${templateId}-${widgetId}`, eventData );

		this.afterInsert();
	}

	afterInsert() {
		return true;
	}
}
